export default __webpack_public_path__ + "static/media/windfarms.a83a14f0.jpg";